(function () {
  'use strict';

  angular
    .module('directive.searchlink', [])

    /* @ngInject */
    .directive('searchLink', ["HttpService", "$location", "$rootScope", function (HttpService, $location, $rootScope) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          element.click(function (event) {
            var product = angular.fromJson(attrs.item);
            if (product) {
              if (product.IDProduct > 0) {
                HttpService.post({
                  url: 'Search/SearchLog',
                  data: {
                    Query: attrs.query,
                    Id: attrs.id,
                    Index: attrs.index,
                    Type: attrs.type
                  }
                });
              }
              if (product.IsDilicom) {
                event.preventDefault();
                $rootScope.$broadcast('showPageLoader', true);
                HttpService.get({
                  url: 'CreateDilicom/' + product.BarCode
                }).then(function (response) {
                  if (response.status === 'OK') {
                    $location.path(response.product.URL);
                  }
                })
                  .catch(function (error) {
                    console.error(error);
                  })
                  .finally(function () {
                    $rootScope.$broadcast('showPageLoader', true);
                  });
              }
            }
          });
          scope.$on('$destroy', function () {
            element.off('click');
          });
        }
      };
    }]);
})();
